<template>
  <div class="d-flex justify-center">
    <div class="pa-8" ref="scrollContainer" style="max-width: 800px">
      <v-btn
        class="mb-4"
        variant="text"
        prepend-icon="mdi-arrow-left"
        @click="$router.back()"
        >Back</v-btn
      >

      <v-card
        class="d-flex bg-accent pa-6 mb-5"
        flat
        rounded="lg"
        style="
          border-left: 1px solid #272727;
          border-right: 3px solid #272727;
          border-top: 1px solid #272727;
          border-bottom: 3px solid #272727;
        "
      >
        <v-icon>mdi-creation</v-icon>
        <div class="ml-4">
          <h2 class="text-h4 mb-0 font-weight-bold">Let's get started!</h2>
          <p class="text-body-1" style="color: rgba(0, 0, 0, 0.65)">
            Setup your accounts and first category to start creating content.
          </p>
        </div>
      </v-card>

      <div>
        <h2 style="color: rgba(0, 0, 0, 0.65)">
          1. Let's connect your account
        </h2>
        <p class="text-body-1" style="color: rgba(0, 0, 0, 0.65)">
          Connect your account to start creating content.
        </p>
        <div class="my-4 d-flex flex-wrap" style="gap: 10px">
          <v-card
            @click="selected_account = account.id"
            v-for="account in accounts"
            :key="account.id"
            rounded="lg"
            :class="selected_account === account.id ? 'bg-accent ' : ''"
            style="
              display: grid;
              grid-template-columns: 20px auto;
              gap: 10px;
              border-left: 1px solid #272727;
              border-right: 3px solid #272727;
              border-top: 1px solid #272727;
              border-bottom: 3px solid #272727;
            "
            class="align-center px-3 py-2"
            width="300"
          >
            <v-img
              width="20"
              height="20"
              contain
              :src="account.profile_picture"
            />
            <p
              style="
                max-width: 250px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
            >
              {{ account.name }}
            </p>
          </v-card>
        </div>
      </div>

      <div v-if="step > 1" class="mt-10">
        <h2 style="color: rgba(0, 0, 0, 0.65)">
          2. What brand do you want to create content for?
        </h2>
        <p class="text-body-1" style="color: rgba(0, 0, 0, 0.65)">
          Select the brand you want to create content for.
          <i>(Only one brand can be selected)</i>
        </p>
        <div class="my-4 d-flex flex-wrap" style="gap: 10px">
          <v-card
            @click="selected_brand = brand.uid"
            v-for="brand in brands"
            :key="brand.uid"
            rounded="lg"
            :class="brand.uid === selected_brand ? 'bg-accent ' : ''"
            style="
              gap: 10px;
              border-left: 1px solid #272727;
              border-right: 3px solid #272727;
              border-top: 1px solid #272727;
              border-bottom: 3px solid #272727;
            "
            class="align-center px-3 py-2"
            width="300"
          >
            {{ brand.name }}
          </v-card>
        </div>
      </div>

      <div v-if="step > 3" class="mt-10">
        <h2 style="color: rgba(0, 0, 0, 0.65)">
          3. What category of content do you want to create?
        </h2>
        <p class="text-body-1" style="color: rgba(0, 0, 0, 0.65)">
          Select the type of content you want to create.
        </p>

        <div class="d-flex flex-wrap mt-8" style="gap: 25px">
          <CategoryCard
            v-for="(category, index) in categories"
            :key="index"
            :color="colors[index]"
            :category="category"
            :selectable="true"
            :selected="selected_categories.includes(category)"
            @selectCategory="
              selected_categories.includes(category)
                ? selected_categories.splice(
                    selected_categories.indexOf(category),
                    1
                  )
                : selected_categories.push(category)
            "
          />
        </div>
      </div>

      <div class="d-flex mb-10" style="width: 800px">
        <div v-if="step === 3" class="mt-4">
          <p class="text-body-1" style="color: rgba(0, 0, 0, 0.65)">
            Generating categories
          </p>
          <p>
            <span class="dot-loader">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </span>
          </p>
        </div>
        <v-btn
          class="mt-8 px-8"
          style="
            border-left: 1px solid #272727;
            border-right: 3px solid #272727;
            border-top: 1px solid #272727;
            border-bottom: 3px solid #272727;
          "
          color="button"
          :disabled="disabled"
          flat
          v-else
          @click="continueStep()"
          >{{ step === 4 ? "Save everything" : "Continue" }}</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import { httpsCallable } from "firebase/functions";
// import { functions } from "@/firebase";
import CategoryCard from "@/components/category/CategoryCard.vue";
export default {
  name: "ActivationWizard",
  components: {
    CategoryCard,
  },
  computed: {
    ...mapState({
      accounts: (state) => state.accounts.accounts,
      brands: (state) => state.workspace.brands,
    }),
    disabled() {
      let disabled = false;
      if (this.step === 1) {
        disabled = this.selected_account === null;
      }
      if (this.step === 2) {
        disabled = this.selected_brand === null;
      }
      if (this.step === 3) {
        disabled = this.selected_categories.length === 0;
      }
      return disabled;
    },
  },
  data() {
    return {
      step: 4,
      colors: [
        "#67d6fa",
        "#cfb8ff",
        "#fa7a68",
        "#ffd978",
        "#c9fa75",
        "#b6b6b6",
        "#ff94d6",
        "#75f7e3",
        "#ffa574",
        "#a7f784",
      ],
      selected_brand: {
        company: "Braingineers",
        ICP: {
          industry: [
            "Digital / tech companies",
            "UX / CX teams",
            "E-commerce / Online platforms",
            "Agencies (UX, CRO, marketing)",
          ],
          company_size:
            "Medium to large organizations (or agencies) with digital products / customer journeys to optimize",
          roles: [
            "UX researchers",
            "CRO / optimization managers",
            "Product owners",
            "Marketing / Customer Experience leads",
          ],
          painPoints: [
            "Unknown or hidden friction in user flows / journeys",
            "Low conversion, drop-off, or engagement rates",
            "Difficulty uncovering subconscious / emotional reasons for behavior",
            "Internal debates about what to prioritize (lack of objective evidence)",
            "Need for more advanced research without in-house neuro / psychology expertise",
          ],
        },
        goldenCircle: {
          why: "To improve business results by improving user experience and revealing deeper, subconscious insights in digital journeys",
          how: [
            "By combining psychology, neuroscience, and UX research to capture implicit behavior (EEG, eye-tracking, behavioral metrics)",
            "Providing a data-driven, low-bias methodology (neuro-usability) that reveals bottlenecks and emotional responses",
            "Offering both full research services *and* self-service / plug-and-play neurolab solutions (licensing, training, platform)",
          ],
          what: [
            "User testing & neuromarketing research of websites, apps, prototypes, videos, etc.",
            "Neuro Lab (plug & play neuroscience research lab solution)",
            "Brainpeek: emotion analytics & user research platform",
            "Benchmark studies / industry benchmarks (neuro UX benchmark)",
            "Consulting, insights reporting, optimization recommendations, training & onboarding",
          ],
        },
        products_services: [
          "Full Service User Testing (neuro-usability research)",
          "Neuro Lab (plug & play lab leasing / self-service)",
          "Brainpeek platform (emotion analytics & user research platform)",
          "Industry / Neuro UX Benchmark Studies",
          "Participant recruitment & management",
          "Consulting, reports & optimization recommendations",
          "Training, workshops, onboarding support",
        ],
        common_rejections: [
          "Too expensive compared to traditional UX testing or analytics tools",
          "Results from neuroscience methods (EEG, eye tracking) seem unclear or difficult to translate into business actions",
          "Skepticism about the validity or scientific rigor of neuromarketing / neuroscience methods",
          "Perception that sample sizes are too small to be representative",
          "Fear of long setup time, technical complexity, or steep learning curve",
          "Preference to keep research in-house with existing tools and UX researchers",
          "Data privacy or compliance concerns around biometric / neurological data",
          "Belief that insights may not directly impact conversion or ROI quickly",
          "Competing priorities (budget allocated to A/B testing, analytics, or marketing tech instead)",
        ],
      },
      selected_account: null,
      selected_tone: null,
      selected_categories: [],
      selected_emojis: null,
      selected_emdashes: null,
      selected_structure: null,
      selected_length: null,
      selected_complexity: null,
      selected_language: null,
      selected_sources: [
        {
          name: "New Neuromarketing",
          url: "https://www.newneuromarketing.com/",
          focus:
            "Bridging academic neuromarketing research with practical marketing use cases",
          competitor: true,
        },
      ],
      sources: [
        {
          name: "Neuromarketing (Roger Dooley)",
          url: "https://www.neurosciencemarketing.com/blog/home",
          focus:
            "Neuroscience applied to marketing, persuasion, consumer psychology",
        },
        {
          name: "New Neuromarketing",
          url: "https://www.newneuromarketing.com/",
          focus:
            "Bridging academic neuromarketing research with practical marketing use cases",
        },
        {
          name: "Neuroscience News – Blogs",
          url: "https://neurosciencenews.com/blogs/",
          focus:
            "Broad neuroscience, psychology, and neurotechnology research updates",
        },
        {
          name: "Simply Neuroscience",
          url: "https://www.simplyneuroscience.org/blog",
          focus:
            "General neuroscience and brain science, accessible to a wide audience",
        },
        {
          name: "Brainwoosh",
          url: "https://www.brainwoosh.com/",
          focus:
            "Curated neuroscience and psychology news for professionals and enthusiasts",
        },
        {
          name: "The BRAIN Blog (NIH / BRAIN Initiative)",
          url: "https://braininitiative.nih.gov/news-events/blog",
          focus:
            "Research updates, tools, and policies in neuroscience from NIH",
        },
        {
          name: "TheBrain.blog",
          url: "https://thebrain.blog/neuroscience/",
          focus:
            "Narrative-driven posts about neuroscience and recent brain research",
        },
        {
          name: "Neuroscience of Branding",
          url: "https://www.neuroscienceof.com/branding-blog",
          focus:
            "Neuroscience insights specifically applied to branding and consumer behavior",
        },
        {
          name: "Mind Hacks",
          url: "https://mindhacks.com/",
          focus:
            "Behavioral neuroscience and cognitive science, with practical twists",
        },
        {
          name: "Frontiers – Consumer Neuroscience",
          url: "https://www.frontiersin.org/research-topics/69938/insights-and-innovations-in-consumer-neuroscience",
          focus:
            "Academic research in consumer neuroscience and behavioral science",
        },
      ],
      lengths: [
        {
          title: "50-100 words (short)",
          value: [50, 100],
        },
        {
          title: "100-300 words (medium)",
          value: [100, 300],
        },
        {
          title: "300-600 words (long)",
          value: [300, 600],
        },
      ],
      emojis: [
        {
          title: "Yes",
          value: true,
        },
        {
          title: "No",
          value: false,
        },
        {
          title: "Only a few emojis",
          value: "only_a_few_emojis",
        },
      ],
      emdashes: [
        {
          title: "Yes",
          value: true,
        },
        {
          title: "No",
          value: false,
        },
      ],
      complexities: [
        {
          title: "Easy",
          value: "easy",
        },
        {
          title: "Medium",
          value: "medium",
        },
        {
          title: "Hard",
          value: "hard",
        },
      ],
      structures: [
        {
          title: "Structure 1",
          value: "structure1",
        },
      ],
      tones: [
        {
          title: "The Empathetic Scientist",
          description:
            "<p>Balances <strong>scientific rigor</strong> with <strong>human warmth</strong>. Blends <strong>neuroscience insights</strong> with compassion for the user experience. Explanations stay <strong>data-grounded</strong> but always return to how real people <strong>feel</strong>, <strong>struggle</strong>, and <strong>succeed</strong>—making the science relatable and people-focused.</p>",
          keywords: ["empathetic", "insightful", "human-centered"],
        },
        {
          title: "The Transparent Innovator",
          description:
            "<p>Centers on <strong>openness</strong> and <strong>clarity</strong>, demystifying methods like <strong>EEG</strong> and <strong>AI</strong> into plain steps. Avoids jargon and emphasizes <strong>honesty</strong>, showing exactly how insights are derived—building <strong>trust</strong> in both the process and the outcomes.</p>",
          keywords: ["transparent", "trustworthy", "clear"],
        },
        {
          title: "The Experience Explorer",
          description:
            "<p><strong>Playful</strong>, <strong>curious</strong>, and <strong>experimental</strong>. Highlights the thrill of uncovering <strong>subconscious patterns</strong> in behavior. Invites readers on a journey—“<strong>let’s explore</strong>,” “<strong>what if</strong>,” “<strong>imagine</strong>”—to position your brand as an <strong>insight-driven pioneer</strong>.</p>",
          keywords: ["curious", "playful", "pioneering"],
        },
        {
          title: "The Strategic Optimizer",
          description:
            "<p><strong>Sharp</strong>, <strong>practical</strong>, and <strong>business-minded</strong>. Translates neuro-UX findings into <strong>actionable takeaways</strong> that drive <strong>conversion</strong>, <strong>retention</strong>, and <strong>growth</strong>. Cuts the fluff and focuses on <strong>measurable outcomes</strong> that matter to decision-makers.</p>",
          keywords: ["strategic", "pragmatic", "results-driven"],
        },
        {
          title: "The Human-Tech Bridge Builder",
          description:
            "<p><strong>Warm</strong>, <strong>accessible</strong>, and <strong>visionary</strong>. Frames neuroscience as the link between <strong>human emotion</strong> and <strong>digital interfaces</strong>. Shows how <strong>data</strong> makes interactions more <strong>humane</strong>, promoting <strong>inclusivity</strong> and meaningful connection.</p>",
          keywords: ["inclusive", "visionary", "harmonious"],
        },
      ],
      categories: [
        {
          name: "Neuro-UX Insights",
          description:
            "<p>Break down fascinating findings from <strong>neuroscience</strong> and <strong>psychology</strong> into practical <strong>UX lessons</strong>. Reveal what happens beneath the surface of user behavior, offering quick, <strong>digestible takeaways</strong>.</p>",
        },
        {
          name: "Behind the Lab",
          description:
            "<p>A peek into Braingineers’ <strong>methods</strong> — from <strong>EEG headsets</strong> to <strong>eye-tracking tools</strong> — explained in a transparent and engaging way. Helps <strong>demystify technology</strong> and builds <strong>trust</strong> through openness.</p>",
        },
        {
          name: "Emotions in Digital Journeys",
          description:
            "<p>Stories and visuals showing how <strong>emotions drive clicks</strong>, <strong>conversions</strong>, and <strong>frustrations</strong>. Highlight surprising emotional responses and how small <strong>design tweaks</strong> make a big difference.</p>",
        },
        {
          name: "Client Impact Stories",
          description:
            "<p>Showcase how <strong>insights</strong> turned into <strong>tangible improvements</strong> for clients. Emphasize <strong>measurable impact</strong> (higher conversion rates, smoother journeys) while staying <strong>human and relatable</strong>.</p>",
        },
        {
          name: "Future of Human-Tech",
          description:
            "<p><strong>Thought-leadership</strong> posts exploring the evolving relationship between <strong>humans</strong> and <strong>digital interfaces</strong>. Spot trends, make <strong>bold predictions</strong>, and share visionary storytelling about the future of <strong>UX and AI</strong>.</p>",
        },
        {
          name: "The Explorer’s Notebook",
          description:
            "<p><strong>Playful</strong>, <strong>curiosity-driven</strong> posts that share experiments, <strong>unexpected discoveries</strong>, or ‘what if’ scenarios. Light, engaging content that sparks <strong>conversation</strong> and positions Braingineers as <strong>innovative explorers</strong>.</p>",
        },
      ],
    };
  },
  methods: {
    async continueStep(next) {
      this.step = next || this.step + 1;
      await this.$nextTick();
      const el = this.$refs.scrollContainer;
      if (el && el.scrollTo) {
        el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
      }
    },
    openLink(url) {
      window.open(url, "_blank");
    },
    async generatePosts() {
      this.selected_categories[0].posts = [];
      this.selected_categories[0].posts = [
        {
          draft:
            "Herken je dit: te veel keuzes maken je besluiteloos maakt en je uiteindelijk niets koopt? Dat is Hick’s Law in de digitale wereld. Stel je voor: een online supermarkt waar de hummus-afdeling 15 verschillende varianten heeft. Een minute geleden wist je nog niet welke hapje er bij je borrel past, maar nu sta je al veteraan in een doolhof van smaken en tekstlabels. Je trekt uiteindelijk een basic optie uit frustratie en loopt weg zonder te kopen. In UX vertalen we dit naar hoge bounce rates, uitgestelde beslissingen en minder vertrouwen in de merk. De les is simpel maar krachtig: geef mensen duidelijke, samenhangende keuzes en laat ze niet verdwalen in een overvloed aan opties.\n\nBij Braingineers draait alles om wat onder de oppervlakte gebeurt: hoe mensen onbewuste cues oppikken, hoe aandacht verschuift en hoe emoties de klik bepalen. We combineren psychologie, neuroscience en UX-onderzoek om bottlenecks en emotionele reacties op te sporen die traditionele analytics missen. Onze Neuro Lab biedt een plug-and-play manier om snel complexe user journeys te testen zonder dat jouw team meteen een heel lab nodig heeft. En met Brainpeek krijgen teams een hands-on beeld van emoties en engagement tijdens elke stap van de reis.\n\nHoe pas je Hick’s Law toe voor betere conversie en minder frictie? Drie praktische stappen:\n1) Beperk het aantal stimuli en keuzes per scherm. Focus op 3–5 opties die echt de meeste waarde leveren en verwijder de rest.\n2) Gebruik progressieve disclosure: verdeel de keuzes in logische categorieën en toon pas extra opties als de gebruiker echt klaar is om verder te klikken. Dit verlaagt cognitieve belasting en versnelt besluitvorming.\n3) Maak de belangrijkste acties opvallend: heldere, contrasterende CTA’s en duidelijke taal die de gewenste handeling expliciet maakt. Geen ruis, wel doelgericht ontwerp.\n\nWaarom werkt dit? Uit neuroscience-gedreven UX we kennen de neiging van gebruikers om cognitieve energie te sparen. Minder opties betekent minder mentale rekentijd, snellere beslissingen en minder kans op uitstel. En omdat beslissingen sneller gaan, kun je ook sneller verder meten wat werkt – conversieratio’s verbeteren, abandons afnemen, en content die wat langer betrokken houdt.\n\nWat Braingineers voor jou team kan betekenen: een betrouwbaar, laag-bias onderzoeksportfolio dat direct bruikbare lessen oplevert. We bieden uitgebreide sessies in ons Neuro Lab, gecombineerd met real-time analyses en concrete aanbevelingen die jouw roadmap voor UX-verbetering aandrijven. Daarnaast kun je met Brainpeek de emotionele reactie van gebruikers volgen en zien welke elementen echt resoneren of juist irritatie oproepen. Door onze methodologie kun je sneller beslissen welke veranderingen echt impact hebben op ROI.\n\nKlaar voor een heldere, datagedreven aanpak die echte verbetering oplevert? Laten we samen een neuro-usability-onderzoek plannen dat jouw team direct kan inzetten. Plan een kennismaking met Braingineers en ontdek waar de verborgen frictie zit en hoeveel omzetpotentieel er schuilgaat achter jouw meest kritieke flows.",
          source: "prev_post_hickslaw",
        },
        {
          draft:
            "Heb je je ooit afgevraagd waarom het volgen van een voortgangsbalk zo’n motivatie geeft tijdens een taak? Het heet de goal gradient, een fenomeen uit de psychologie: hoe dichter je bij een doel komt, hoe harder je gaat werken. In UX vertaalt dit zich in gebruikers die sneller voltooien als ze duidelijke stappen en tastbare mijlpalen zien. Een simpele voortgangsbalk kan een wereld van verschil maken in hoe lang iemand ergens bij blijft en of hij een aankoop afrondt of een formulier invult. \n\nMaar hoe vertaal je dat naar echte productontwerpen die wérkelijk impact hebben op conversie en time-on-task? Bij Braingineers geloven we dat kleine visuele signalen enorme effecten kunnen hebben op gedrag. Onze aanpak combineert inzichten uit neurologie en psychologie met hands-on UX-onderzoek, zodat je niet alleen weet dat iets werkt, maar ook waarom en voor wie.\n\nDrie concrete manieren om de goal gradient te benutten:\n• Toon het totale aantal stappen én waar de gebruiker zich in dat proces bevindt. Voorbeelden: 5 stappen op een checkout, 3 stappen bij het aanmaken van een account. Duidelijke telling vermindert onzekerheid en verhoogt voltooingskansen.\n• Visualiseer vooruitgang met een duidelijke progress bar, consistente checks of micro-zoemen die voortgang bevestigen. Het menselijke brein houdt van visuele feedback; het geeft een signaal dat “we bijna klaar zijn.”\n• Gebruik realistische, ingezette tijdsverwachtingen en kleine mijlpalen die haalbaar lijken. Laat bijvoorbeeld tussentijds zien dat de volgende stap kort is of meteen resultaat oplevert.\n\nWaarom dit effectief is vanuit neuro UX-perspectief? Het brein zoekt bevestiging en tastbare wins; elke stap zet een kleine dopamine-dop aan. Dit verhoogt betrokkenheid, vermindert afhaak en versnelt de besluitvorming, wat direct vertaalt naar lagere drop-off en hogere betrokkenheid – precies wat jouw digitale productscore nodig heeft.\n\nHoe Braingineers dit mogelijk maakt? We bieden niet alleen inzichten, maar ook praktische, uitvoerbare aanbevelingen. Onze Neuro Lab laat zien hoe progress indicators, stapsgewijze disclosure en duidelijke voortgangscommunicatie in jouw specifieke context presteren. En met Brainpeek kunnen teams exact volgen hoe gebruikers reageren op elke mijlpaal: zien we minder frictie bij de bewuste stappen en meer vertrouwen bij elke volgende? Zo ja, dan hebben we bewijs dat de aanpak werkt en kun je verantwoord investeren in verdere optimalisatie.\n\nWil je weten hoe jouw funnel presteert op basis van de goal gradient en welke kleine verbeteringen direct het succes verhogen? Laten we een korte sessie plannen waarin we jouw belangrijkste flows in kaart brengen en concrete, prioriteerbare stappen voorstellen die echt verschil maken.",
          source: "prev_post_goalgradient",
        },
        {
          draft:
            "In zwaar geautomatiseerde interfaces denken velen: meer functies, sneller werk. Dat klinkt logisch, maar is vaak precies het omgekeerde. Een overvol ontwerp verhoogt cognitieve belasting, verwarring en fouten – en uiteindelijk kost het meer tijd dan het oplevert. De proefschriftachtige conclusie uit onderzocht ontwerp laat zien: zelfs ervaren gebruikers verliezen sneller het overzicht wanneer er te veel opties zijn. De oplossing is niet minder functionaliteit, maar slimmer organiseren van de functies die er echt toe doen.\n\nHoe kun je dit praktisch toepassen zonder inleveren op functionaliteit? Drie principes die we bij Braingineers toepassen:\n• Feature-audit: identificeer de top 3–5 tools die 80% van de gebruikers echt gebruiken. Verberg de minder gebruikte opties achter een Expert-modus of contextuele menu’s. Zo houden we de kernervaring helder, maar bieden we nog steeds geavanceerde opties voor power users.\n• Progressive disclosure: laat geavanceerde functies zien alleen wanneer de gebruiker die realistisch nodig heeft. De rest blijft verborgen maar beschikbaar wanneer dat nodig is. Dit verlaagt cognitieve belasting en verbetert taakvoltooiing.\n• Meet impact: test telkens afzonderlijk de prestaties van elke functie met A/B-testen en nauwkeurige metrics. Zo kun je de waarde van elk element precies bepalen en voorkom je het samenvoegen van uiteenlopende metrics die het resultaat vertroebelen.\n\nWaarom werkt dit op de lange termijn? Mensen voelen zich minder overweldigd en hebben meer vertrouwen als wat ze zien direct relevant lijkt. Dat vertaalt zich in betere task success rates, minder fouten en hogere tevredenheid. Het gevolg: betere retentie, hogere conversie en sneller ROI op de UX-investeringen.\n\nWat doen wij bij Braingineers concreet? We helpen organisaties bij het uitvoeren van een gestructureerde feature-audit en bij het opzetten van progressive disclosure, ondersteund door neuro-usability-onderzoek zodat je weet welke veranderingen echt impact hebben. Onze Neuro Lab laat zien hoe gebruikers reageren op de herontworpen flows en Brainpeek geeft inzicht in emoties en betrokkenheid. Het resultaat is een productervaring die zowel krachtig als leesbaar is – voor jouw doelgroep, met minder ruis en meer conversie.\n\nDenk jij dat jouw product baat heeft bij minder ruis en meer focus? Laten we samen kijken waar jouw frictie zit en welke onderdelen onmiddellijke ROI opleveren. Plan een korte sessie met Braingineers; we brengen jouw top 3–5 flows in kaart en leveren concrete aanpassingen die echt werken.",
          source: "prev_post_featureheavy",
        },
        {
          draft:
            "Waarom voelen mensen zich sneller verplicht iets terug te doen als iets gratis wordt aangeboden? In de winkel is reciprocity een bekende tactiek: de kassa biedt een gratis drankje aan, en mensen voelen zich haast om iets terug te doen. Digitale producten spelen dit spel ook – gratis proefperiodes, waardevolle content of een inspirerend verhaal zijn allemaal manieren om vertrouwen te winnen voordat de klant iets koopt. Maar hoe vertaal je dit naar UX-design dat echt iets oplevert voor ROI en loyaliteit?\n\nDe kernwaarden die we bij Braingineers toepassen: eerst geven, daarna vragen. Value-first interacties verminderen the fear of commitment en verhogen de kans dat gebruikers converteren wanneer ze klaar zijn. Hoe doen we dat eigenlijk?\n• Gratis proefperiode: laat gebruikers direct kennismaken met de kernwaarde van jouw product; geef resultaten die zij kunnen ervaren zonder betalen. Dit verlaagt de drempel en verhoogt de kans op langdurige inzet.\n• Educatieve content: webinars, blogposts en korte tutorials die concreet laten zien hoe jouw oplossing een probleem oplost. Dit bouwt vertrouwen op en verlaagt risico-aversie.\n• Inspiratie en voorbeelden: laat mogelijkheden zien die medewerkers aanspreken in hun dagelijkse werk, zoals klantcases of scenario’s die resoneren met hun context. Dit geeft richting en motiveert tot actie.\n\nMaar eerlijk is eerlijk: zonder toetsing blijft het een voorspelling. Daarom helpen we met Brainpeek om te meten hoe deze waarde-theorie presteert in jouw specifieke context. Welke elementen van reciprocity leiden tot beter engagement en welke tot weerstand? Welke content versnelt de beweging van interesse naar aankoop, en welke vooral engagement oplevert zonder direct te koop te staan?\n\nHoe Braingineers dit omzet in concrete business outcomes? We adviseren over strategie en voeren vervolgens neuro-usability-onderzoeken uit die de impact van reciprocity-attributen op aandacht, emoties en intentie meten. We leveren verantwoorde, concrete aanbevelingen en een implementatiepad dat rekening houdt met privacy en compliance. Het doel is duidelijk: win vertrouwen, verhoog conversie en maak van je digitale interactions een eerlijke, waardevolle ruil.\n\nWil jij weten hoe reciprocity jouw UX- en conversie-strategie kan versterken? Laten we samen het pad uitstippelen: welke waarde kun jij gratis leveren, en hoe kun je dit measurably koppelen aan ROI? Plan een korte sessie met Braingineers en ontdek welke gratis offers het meeste effect hebben op jouw doelgroep.",
          source: "prev_post_reciprocity",
        },
        {
          draft:
            "Autoplay video lijkt een makkelijke manier om engagement te verhogen, maar in de praktijk werkt het vaak tegen. De gebruiker voelt zich gecontroleerd: een automatische video start terwijl hij niet klaar is om te kijken. Uit verschillende studies blijkt dat autoplayieert content de bounce rate kan verhogen en de totale bekeken tijd kan verlagen. Gebruikers willen controle over wat er gebeurt op de pagina; ze willen kunnen kiezen wanneer ze iets zien. De oplossing is niet per se minder media, maar meer regie: laat de gebruiker kiezen wat hij wilt zien en wanneer.\n\nWat kun je nu concreet doen om autoplay te vermijden maar toch betrokkenheid te stimuleren? We adviseren drie benaderingen:\n• Standaard klik-om-te-spelen: start pas wanneer de gebruiker activeert – de controle blijft bij hen. Dit verlaagt irritatie en verhoogt vertrouwen.\n• Hover previews: laat een kort, stil en gereduceerd beeld zien als iemand met de muis over een video beweegt. Zo verleid je met previews zonder de gebruiker te verplichten te kijken.\n• A/B-test engagement: vergelijk engagement- en conversiemetrics tussen autoplay en klik-om-te-spelen en laat de resultaten spreken. Daarnaast is privacy en gebruikerscontrole cruciaal; zorg voor duidelijke opt-ins en duidelijke microcopy.\n\nIn de praktijk merken we dat bedrijven vaak betere prestaties zien als ze de controle bij de gebruiker leggen, vooral op mobiele apparaten waar dataverbruik en frustratie extra impact hebben. Bij Braingineers helpen we teams om autoplay te vervangen door een gecontroleerde ervaring die nog steeds de gewenste acties stimuleert. We testen verschillende fasen: welk type content werkt het best in een klik-om-te-spelen-omgeving, wanneer is een korte previews genoeg en waar levert het juist extra waarde op.\n\nHoe werkt Brainpeek hieraan mee? Door emoties en aandacht te volgen terwijl gebruikers beslissen om wel of niet te klikken, krijg je inzicht in wat de content precies triggerpt en of de gekozen aanpak indeed de gewenste intenties versterkt. Je krijgt duidelijke aanbevelingen die direct toepasbaar zijn in jouw flows en contentstrategie.\n\nWil jij dat jouw video-ervaring de juiste balans vindt tussen controle en engagement? Plan een korte sessie met Braingineers en ontdek hoe jouw pagina’s eruitzien wanneer gebruikers de regie weer in eigen handen hebben, en welke metrics aantonen dat de verandering ROI oplevert.",
          source: "prev_post_autoplay",
        },
        {
          draft:
            "Tooltips lijken een gemakkelijke manier om gebruikers te helpen bij complexe formulieren, maar ze zitten niet altijd in de goede hoek. Uit onderzoek blijkt dat always-visible tooltips de eerste-tijd-foutkans kunnen verlagen, maar de totale taakduur ook kunnen verhogen. Consumenten worden regelmatig onderbroken en moeten telkens lezen waar ze hulp kunnen vinden. In veel gevallen doet het meer kwaad dan goed: continue hints kunnen de flow verstoren en het leerproces vertragen. De oplossing is read-on-demand help – hulp die verschijnt op het juiste moment, wanneer de gebruiker er daadwerkelijk behoefte aan heeft.\n\nHoe implementeer je dit effectief in jouw product? Drie praktische richtlijnen:\n• On-demand hulp: laat tooltip-tekst verbergen achter een hulp-icoon of verschijnt pas bij hover/tap. Zo hou je de interface schoon en geven gebruikers zelf aan waar ze hulp nodig hebben.\n• Vertraagde triggers: stel een korte wachttijd in (bijvoorbeeld 500 ms) voordat een tooltip verschijnt om onbedoelde triggers te voorkomen.\n• Prestatiemeting: meet zowel foutmarges als taakduur met en zonder persistente hints, zodat je zeker weet welke aanpak sneller en accurater is in jouw context.\n\nWaarom dit werkt vanuit neuro UX-perspectief? Huidige inzichten tonen aan dat on-demand ondersteuning vaak net zo effectief is als passieve hints, maar zonder de flow te onderbreken. Het gaat erom de juiste informatie op het juiste moment aan te bieden. Braingineers helpt teams bij het ontwerpen van hints die samenhangen met wat de gebruiker op dat moment probeert te bereiken, in plaats van standaard pop-ups die ongemerkt irritant kunnen zijn.\n\nWat kunnen wij betekenen voor jouw product? We helpen je om tooltips te herontwerpen richting on-demand ondersteuning, en we testen de impact via neuro-usability-methoden die laten zien welke hints bijdragen aan betere task success en minder cognitieve belasting. Brainpeek geeft inzicht in de emoties die de hints oproepen en bij welke taken ze juist helpen of juist afleiden. Met onze aanpak kun je de juiste balans vinden tussen ondersteuning en onnodige afleiding.\n\nWil je ontdekken of jouw tooltip-strategie de flow verbetert of juist remt? Plan een korte sessie met Braingineers. We brengen jouw huidige tooltip-implementatie in kaart, testen alternatieven en leveren concrete aanbevelingen die direct inzetbaar zijn.",
          source: "prev_post_tooltips",
        },
      ];

      // let data = {
      //   sources: this.sources.filter((s) =>
      //     this.selected_sources.includes(s.url)
      //   ),
      //   brand: this.selected_brand,
      //   language: this.selected_language || "English",
      //   length: `Between ${this.selected_length[0]} and ${this.selected_length[1]} words`,
      //   complexity: this.selected_complexity,
      //   category: this.selected_categories[0],
      //   tone: this.selected_tone,
      //   previous_posts: this.accounts
      //     .find((a) => a.id === this.selected_account)
      //     .feed.elements.map((p) => p.commentary),
      // };
      // console.log(data);
      // const wizard = httpsCallable(functions, "activationWizard");
      // const result = await wizard(data);
      // console.log(JSON.parse(result.data).items);
      // this.selected_categories[0].posts = [JSON.parse(result.data).items];
    },
  },
};
</script>

<style scoped>
.dot-loader {
  display: inline-block;
  margin-left: 5px;
}
.dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  margin: 0 1px;
  border-radius: 50%;
  background: #333;
  opacity: 0.4;
  animation: fadeDots 1s infinite;
}
.dot:nth-child(1) {
  animation-delay: 0s;
}
.dot:nth-child(2) {
  animation-delay: 0.2s;
}
.dot:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes fadeDots {
  0% {
    opacity: 0.4;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.4;
  }
}
</style>
